const getFilteredProps = (props: any): any => {
  const ignoreKeys = ["isPasswordVisible", "onIconClick", "onTextClick"];
  const updateProps: any = {};
  Object.keys(props).forEach((key: string) => {
    if (!ignoreKeys.some((i) => i === key)) {
      const value = props[key];
      // eslint-disable-next-line fp/no-mutation
      updateProps[key] = value;
    }
  });
  return updateProps;
};

const CommonUtils = {
  getFilteredProps,
};

export default CommonUtils;
